import classNames from 'classnames';

import { Space } from '@sravni/react-design-system/lib/Space';

import { open } from '@src/helpers/navigationHelper';
import { useBrandingContent } from '@src/reducers/branding';
import { isServer } from '@src/utils';
import { ClientOnly } from 'shared/ui/ClientOnly/ClientOnly';
import { PIXEL_DISPLAY_WRAPPER_STYLES } from 'widgets/LightweightCard/ui/LightweightCard.config';

import { SponsoredMenu } from '../SponsoredMenu/SponsoredMenu';

import { ADENGI_COMPANY_NAME } from './ADengiBanner.config';
import styles from './ADengiBanner.module.scss';
import { ADengiDisclaimer } from './components/ADengiDisclaimer';

interface Props {
  isShowDisplayPixel: boolean;
}

export function ADengiBanner({ isShowDisplayPixel }: Props) {
  const variant = useBrandingContent();
  const handleClick = () => {
    open({ href: variant?.analytics?.click, features: 'noopener', target: '_blank' });
  };
  const title = variant?.sponsor?.popover?.title || ADENGI_COMPANY_NAME;

  return (
    <>
      <div className={classNames(styles.advertising, 'desktop:hidden')}>
        <SponsoredMenu company={title} />
      </div>
      <div className={styles.container}>
        <div onClick={handleClick}>
          <Space className={styles.logoContainer}>
            <img alt="Лого" {...variant.logo} className={styles.logo} />
          </Space>
          <Space direction="column" align="center">
            <img alt="Лого" {...variant.image} />
          </Space>
          <ADengiDisclaimer heading={variant?.sponsor?.title} />
        </div>
        <ClientOnly>
          {!isServer && isShowDisplayPixel && variant?.analytics?.display && (
            <img alt="" style={PIXEL_DISPLAY_WRAPPER_STYLES} src={variant?.analytics?.display} />
          )}
        </ClientOnly>

        <div className={classNames(styles.advertising, 'mobile:hidden')}>
          <SponsoredMenu company={title} />
        </div>
      </div>
    </>
  );
}

ADengiBanner.displayName = '';
